import { observable, reaction } from 'mobx';
import { useHistory } from 'react-router-dom';
import useMount from '@src/utils/hooks/use-mount';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import { jumpPage } from '@src/utils/common-util';
import reload from '@src/utils/reload';

class TabMenuStore {
  constructor(options = {}) {
    Object.assign(this, options);
  }

  tabMenuSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      slidesPerView: 3,
      spaceBetween: '5.26%',
      autoplay: false,
      centeredSlides: true,
      allowTouchMove: false
    }
  });

  $history = null;

  @observable isActive = false;
  @observable currentMechaId = '';

  @observable tabList = [];

  toMechaPage = id => {
    if (!IS_DEV_ENV) {
      const url = 'mecha-unit.html';
      jumpPage(url, '?id=' + id);
    } else {
      this.$history.push('/mecha-unit?id=' + id);
      reload();
    }
  };

  onPrev = () => {
    this.tabMenuSwiper.goPrev();
  };
  onNext = () => {
    this.tabMenuSwiper.goNext();
  };

  use() {
    this.$history = useHistory();

    reaction(
      () => this.tabList.length,
      () => {
        if (this.tabList.length) {
          this.tabList.forEach((item, index) => {
            if (item.isActive) {
              this.tabMenuSwiper.onChange(index);
            }
          });
        }
      }
    );

    useMount(() => {});
  }
}

export default TabMenuStore;
